/**
 * AV-15664 "New Contacts" metrics for interactions widgets. Keys, labels and
 * picker options live here so the widget builder and the stats tiles cannot
 * drift apart. Keys mirror ReportNewContactsHelper on the backend.
 */
export const NEW_CONTACTS_TOTAL_KEY = "new_contacts";
export const NEW_CONTACTS_STATUS_PREFIX = "new_contacts_status_";
export const NEW_CONTACTS_GROUP_BY = "new_contacts_status";
export const NEW_CONTACTS_TOOLTIP =
    "Each new contact counted once, by its latest interaction in the date range. " +
    "Contacts created in the walk app only; imported contacts are not counted. " +
    "The user filter applies to the person who made that latest interaction.";

export interface StatusLike {
    id: number | string;
    name: string;
}

export interface StatsMetricOption {
    name: string;
    value: string;
}

const GO_APP_STATUSES: StatusLike[] = [
    { id: 7, name: "Answered (Go App)" },
    { id: 8, name: "Not Interested (Go App)" },
];

export function isNewContactsMetric(key: string): boolean {
    return key === NEW_CONTACTS_TOTAL_KEY || key.startsWith(NEW_CONTACTS_STATUS_PREFIX);
}

export function newContactsStatsOptions(
    statuses: StatusLike[],
    goAppEnabled: boolean
): StatsMetricOption[] {
    const options: StatsMetricOption[] = [
        { name: "New Contacts", value: NEW_CONTACTS_TOTAL_KEY },
    ];
    const all = goAppEnabled ? statuses.concat(GO_APP_STATUSES) : statuses;
    for (const status of all) {
        options.push({
            name: `New Contacts: ${status.name}`,
            value: NEW_CONTACTS_STATUS_PREFIX + status.id,
        });
    }
    return options;
}

export function newContactsLabels(
    statuses: StatusLike[],
    goAppEnabled: boolean
): { [key: string]: string } {
    const labels: { [key: string]: string } = {};
    for (const option of newContactsStatsOptions(statuses, goAppEnabled)) {
        labels[option.value] = option.name;
    }
    return labels;
}
